export default __webpack_public_path__ + "static/media/fa-solid-900.e182c967.woff2";